module.exports = __webpack_public_path__ + "static/media/Rutherford B. Hayes - 1876.fb769468.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Rutherford B. Hayes - 1876.jpg
// module id = 546
// module chunks = 0